import { format } from 'date-fns';

import { BUSINESS_UNITS } from '../src/constants/BusinessUnits';
import { SERVICES } from '../src/constants/Services';

const dateIsValid = (date: number) => {
	return !Number.isNaN(new Date(date).getTime());
};

export const formatDate = (date: any, short = false) => {
	if (!dateIsValid || !date) return '';
	return format(
		new Date(date.substring(0, 10)),
		short ? 'dd LLL' : 'dd LLLL yy'
	);
};

export const formatMoney = (value: number) => {
	const SI_SYMBOL = ['', 'k', 'm', 'b'];

	const tier = (Math.log10(value) / 3) | 0;
	const suffix = SI_SYMBOL[tier];
	const scale = Math.pow(10, tier * 3);

	const scaled = value / scale;

	return '£' + scaled.toFixed(1) + suffix;
};

export const getArrayOfFilterableServices = () => {
	return Object.keys(SERVICES)
		.map((key) => SERVICES[key])
		.filter((service) => service.uuids);
};

export const unFlattenResults = (results: []) => {
	return results.map((result) => ({
		node: result,
	}));
};

export const filterResults = (
	results: [],
	queryFilter: any,
	component: React.ReactNode
) => {
	const desiredComponent = component;

	return results.filter((result: any) => {
		const story = JSON.parse(
			result?.node ? result.node.content : result.content
		);
		const { business_unit, component } = story;

		if (desiredComponent !== component) return;
		if (queryFilter === 'all' || !queryFilter) return results;

		// Find the matching service
		const queriedServiceUuids = getArrayOfFilterableServices().filter(
			(service) => service.value === queryFilter
		)[0].uuids;

		// If this posts business_unit is one of the matching services uuids
		return queriedServiceUuids.includes(business_unit);
	});
};

export const filterCaseStudies = (
	results: [],
	queryFilter: any,
	component: React.ReactNode
) => {
	const desiredComponent = component;

	return results.filter((result: any) => {
		const story = JSON.parse(
			result?.node ? result.node.content : result.content
		);
		const { business_unit, component } = story;

		if (desiredComponent !== component) return;
		if (queryFilter === 'all' || !queryFilter) return result;
		if (getBusinessUnitFromLabel(queryFilter) === business_unit) return result;
	});
};

export const getPostsInPageString = (
	limit: number,
	skip: number,
	total: number
) => {
	const fromPosts = skip + 1;
	const maxPosts = limit + skip;
	const toPosts = maxPosts > total ? total : maxPosts;

	return `${fromPosts} - ${toPosts} of ${total}`;
};

export const getArrayOfFilterableBusinessUnits = () => {
	return Object.keys(BUSINESS_UNITS)
		.map((key) => BUSINESS_UNITS[key])
		.filter((businessUnit) => businessUnit.uuid);
};

export const getBusinessUnitFromID = (uuid) => {
	const label = getArrayOfFilterableBusinessUnits().find(
		(unit) => unit.uuid === uuid
	);

	if (typeof label !== 'undefined' && label != null) {
		return label.label;
	} else {
		return 'Group';
	}
};

export const getBusinessUnitFromLabel = (label) => {
	const units = getArrayOfFilterableBusinessUnits().find(
		(unit) => unit.label === label
	);

	if (typeof units !== 'undefined' && units != null) {
		return units.uuid;
	} else {
		return '';
	}
};
export const slugify = (str: string, replace: string = '-') =>
	str
		.toLowerCase()
		.trim()
		.replace(/[^\w\s-]/g, '')
		.replace(/[\s_-]+/g, replace)
		.replace(/^-+|-+$/g, '');
